import builder from '../builder';
import RatingStarRibbon from '../../streamline-icons/bold/rating-star-ribbon.svg';

export default builder('IconRatingStarRibbonBold', RatingStarRibbon);
